import React, { useState, useEffect, useContext } from "react";
import NumberFormat from "react-number-format";
import { getCostMonthSelector } from "../../services/dashApiService";
import { GenericModal } from "../common/GenericModal";
import { DiseaseGroupContext } from "../../contexts/diseaseGroupContext";
import { XCircle } from "../common/IconsV2";

export const NavBarYourCosts = ({
	costsFilter,
	onCostsFilter,
	onAddCost,
	totalCosts,
	costsMonth,
}) => {
	const keyToButtonMap = {
		thisMonth: "current",
		lastMonth: "previous",
	};
	const [isShowingDialog, setIsShowingDialog] = useState(false);

	const [activeButton, setActiveButton] = useState();
	useEffect(() => {
		setActiveButton(costsFilter);
	}, []);

	const [isMonthLocked, setIsMonthLocked] = useState(true);
	useEffect(() => {
		getCostMonthSelector()
			.then((result) => {
				if (result.success) {
					if (activeButton) {
						const selector = result.data[keyToButtonMap[activeButton]];
						setIsMonthLocked(selector.locked);
					}
				} else {
					if (result.err) {
						console.error("Dash API Error: ", result.err);
					} else {
						console.error(
							"Unknown error occurred when calling 'getCostsMonthSelector"
						);
					}
					setIsMonthLocked(true);
				}
			})
			.catch((error) => {
				console.error("Error in CostPopup: ", error);
				setIsMonthLocked(true);
			});
	}, [activeButton]);

	const handleClick = (id) => {
		setActiveButton(id);
		onCostsFilter(id);
	};

	const handleAddCost = () => {
		if (isMonthLocked) {
			setIsShowingDialog(true);
		} else {
			onAddCost(null);
		}
	};

	const { theme } = useContext(DiseaseGroupContext);
	const activeClasses = "text-white bg-black font-bold";

	return (
		<>
			<div className={"flex justify-between"}>
				<div className={"flex-1 pt-2"}>
					<ul className={`flex gap-2 items-center`}>
						<li className={"flex-1 flex items-center"}>
							<button
								onClick={() => handleClick("lastMonth")}
								className={`w-full ${
									activeButton === "lastMonth"
										? activeClasses
										: "bg-gray-100 text-black"
								} text-xs sm:text-sm sm:leading-4 rounded-full py-1.5 sm:py-3`}
							>
								Last Month
							</button>
						</li>
						<li className={"flex-1 flex items-center"}>
							<button
								onClick={() => handleClick("thisMonth")}
								className={`w-full ${
									activeButton === "thisMonth"
										? activeClasses
										: "bg-gray-100 text-black"
								} text-xs sm:text-sm sm:leading-4 rounded-full py-1.5 sm:py-3`}
							>
								This Month
							</button>
						</li>
						<li>
							<button
								className={"flex items-center justify-right ml-5"}
								onClick={handleAddCost}
							>
								<span className={"text-xs sm:text-sm mr-1.5"}>Add</span>
								<XCircle
									className={`w-6 sm:w-12 rotate-45 transform ${theme
										.primary()
										.text()}`}
								/>
							</button>
						</li>
					</ul>

					<div
						className={`flex text-lg xs:text-xl font-bold justify-start pb-1 pt-4 sm:py-5 px-1 ${theme
							.primary()
							.text()}`}
					>
						<span className={"mr-0.5"}>£</span>
						<NumberFormat
							thousandSeparator={true}
							displayType={"text"}
							decimalScale={2}
							fixedDecimalScale={true}
							value={totalCosts}
						/>
						<span
							className={`${theme
								.primary()
								.text()} text-lg xs:text-xl font-normal pl-2`}
						>
							Total for {costsMonth}
						</span>
					</div>
				</div>
			</div>

			<GenericModal
				show={isShowingDialog}
				onClose={() => setIsShowingDialog(false)}
				backText={"OK"}
				title={"WARNING"}
				text={`You can't add any more costs to ${activeButton === "thisMonth" ? "this month" : "last month"}`}
				currentTheme
			/>
		</>
	);
};
